/**
 * Probe 한 건 — 샘플 확보 명령과 그 증거.
 *
 * Owns:
 * - 화면이 다루는 Probe · Revision 값과 종료 판정.
 *
 * Does not own:
 * - wire 응답 해석 — `api/probeApi.ts`. 상태 문구 · 색 — `feature/probeStatus.ts`.
 * - 실패 사유 문구 — `feature/probeFailureMessage.ts`.
 */
export type ProbeState = "requested" | "collecting" | "sample_ready" | "failed";

export const PROBE_STATES: readonly ProbeState[] = [
  "requested",
  "collecting",
  "sample_ready",
  "failed",
];

/** 아직 결과가 나오지 않은 상태. 이 구간에서만 재요청이 같은 건으로 합쳐진다(서버 계약). */
const OPEN_PROBE_STATES: readonly ProbeState[] = ["requested", "collecting"];

export type RevisionKind = "listing_digest" | "commit_sha";

export type Revision = {
  /** 매핑 · POC 는 이 값으로 주소를 만든다(`/v1/revisions/{uuid}/…`). */
  uuid: string;
  kind: RevisionKind;
  identifier: string;
  /** 원본 prefix **전체**의 파일 수. 샘플에 담긴 수가 아니다. */
  fileCount: number;
  /** 원본 prefix **전체**의 바이트. 샘플 크기가 아니다. */
  totalBytes: number;
  listedAtMs: number;
};

export type Probe = {
  uuid: string;
  datasetUuid: string;
  state: ProbeState;
  episodeTarget: number;
  /**
   * 고른 episode 의 ID. 세 상태가 서로 다른 뜻이다 —
   * `null` 은 아직 고르지 않음, `[]` 는 고른 것이 없음, 값은 그 목록이다.
   */
  selectedSourceIds: readonly string[] | null;
  /** 샘플의 저장소 좌표. 다운로드 URL 이 아니다(그 표면은 아직 없다). */
  sampleRef: string | null;
  manifestDigest: string | null;
  failureCode: string | null;
  failureDetail: string | null;
  revision: Revision | null;
  createdAtMs: number;
};

export function isProbeOpen(state: ProbeState): boolean {
  return OPEN_PROBE_STATES.includes(state);
}
